import { useNavigate } from 'react-router-dom';

import {CcStepper2, StepperNavButtons} from '../commonComponents/stepper'
import {LionLoaderGradient} from '../commonComponents/generalComponents'
import { Icon as Iconify } from '@iconify/react';
import { IconButton } from '@mui/material';
import { useEffect, useState } from 'react';
import {SnippetCodeViewer} from '../commonComponents/snippetGeneric'


import { useParams } from "react-router-dom";
import axios from 'axios';

import { TimedImagesElementManager } from '../workflows/timedImagesWorkflow';

import { getErrorListFromYupError, getErrorMessage, snippetDataValidationSchemaTimedImages } from '../components/helperErrors'

// ----------------------------------------------------------------------


export default function TimedImagesWizard(props) {
  const [currentStepIndex, setCurrentStepIndex] = useState(0);
  const [snippetData, setSnippetData] = useState(undefined)


  const [successHtmlMsg, setSuccessHtmlMsg] = useState('');
  const [showErrorMsg, setShowErrorMsg] = useState(false);
  const [showLoader, setShowLoader] = useState(false);
  const [showSuccessMsg, setShowSuccessMsg] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  let params = useParams();
  const navigate = useNavigate();

  const [activeErrorList, setActiveErrorList] = useState([]);


  useEffect(() => {
      //console.log(params)
    if (params.snippetId !== undefined) {
      getSnippetInfo(params.snippetId)
    }
  }, [params])

  const getSnippetInfo = async (snippetId) => {
    try {  
      const url = `${process.env.REACT_APP_LION_API_URL}/Snippets/${snippetId}`;
      const response = await axios.get(url);
      let data = response.data;
      data = {...data, snippetSettings: JSON.parse(data.snippetSettings)}
      setSnippetData(data);

    } catch (error) {
      console.log(error);
    }
  }

  const handleNavChange = async(navInfo) => {
    if (navInfo.actionType === 'Navigation'){
      setCurrentStepIndex(navInfo.nextIndex);
    }
    else if (navInfo.actionType === 'Submit') {
      let valid = true
      try {
        //console.log(snippetData)
        snippetDataValidationSchemaTimedImages.validateSync(snippetData, {abortEarly: false});
        setActiveErrorList([])
      }
      catch (e) {
        //console.log(JSON.parse(JSON.stringify(e)))
        const errorList = getErrorListFromYupError(e)
        setActiveErrorList(errorList)
        valid = false;
      }

      
      if (valid) {
        setCurrentStepIndex(navInfo.nextIndex);
        await submitData();
      }
    }
  }

  const submitData = async () => {

    setShowLoader(true);
    setSuccessHtmlMsg('');
  
    try {
        let url = `${process.env.REACT_APP_LION_API_URL}/Snippets/create/19`;
        if (params.snippetId !== null) url = `${process.env.REACT_APP_LION_API_URL}/Snippets/update/19/${params.snippetId}`;
    
        const response = await axios.post(url, {...snippetData, snippetSettings: JSON.stringify(snippetData.snippetSettings)});
        // const response = await fetch(url, { method: "POST", body: JSON.stringify(dataToPost) });    
        // response.data = await response.json();
  
        setSuccessHtmlMsg(response.data);
        setShowSuccessMsg(true);
    } catch (error) {
      setShowSuccessMsg(false);
      setShowErrorMsg(true);
      console.log(error);
    }
    setShowLoader(false);
    setSubmitted(true);
  }


  const handleElementChange = (snippetInfo) => {
    setSnippetData(snippetInfo)
    try {
      snippetDataValidationSchemaTimedImages.validateSync(snippetInfo, {abortEarly: false});
      setActiveErrorList([])
    }
    catch (e) {
      const errorList = getErrorListFromYupError(e)
      setActiveErrorList(errorList)
      //return false;
    }

  }
  const handleClose = () => {
    navigate("/ph/timedimages")
  }

 return (
  <>
    <div className='border border-gray-300 rounded-md shadow-md p-1'>
    <div className='flex flex-row-reverse'>
      <IconButton variant="contained" sx={{color: '#d1d5db'}} onClick={handleClose} >
        <Iconify icon="material-symbols-light:cancel-outline" width="44px" color='#d1d5db' />
      </IconButton>

    </div>
    <CcStepper2 steps={[{ name: 'Configure timeline', href: '#' },
                    { name: 'Get Element', href: '#' },]}
        currentStepIndex={currentStepIndex}
    />

    {currentStepIndex === 0 && 
        <TimedImagesElementManager
            onChange={handleElementChange}
            snippetInfo={snippetData}
            validationErrorsList={activeErrorList}
        />
      
      
    }

    {currentStepIndex === 1 && <div className='flex justify-center'>
      {showLoader && <LionLoaderGradient /> }
      {showSuccessMsg && <div className='flex flex-col w-full items-center'>
      <SnippetCodeViewer numSnippets={1} html={successHtmlMsg} />

      </div>
      }
    
    </div>
    }

    <StepperNavButtons totalSteps={2}
        currentStepNum={currentStepIndex}
        onChange={handleNavChange}
        showClose={submitted}
        onClose={handleClose}
    />
    </div>

  </>
);
}
